import { useMemo } from "react"
import { MultiUserSelect } from "../../../components/Selectors/MulltiUserSelector"
import { BackendFilter } from "../../../interfaces/sessions"
import { SessionAgentsColumns } from "../../../interfaces/table"
import { useUserData } from "../users/user-data-hook"

export function useSelectedRepsFromFilter(filter: BackendFilter): MultiUserSelect[] {
  // Get user data from centralized hook
  const { user, allVisibleUsers, sortedUserGroupInfo, allVisibleUserIds } = useUserData();

  return useMemo(() => {
    const targetColumnNames = [SessionAgentsColumns.CREATOR_AGENT_ID, SessionAgentsColumns.FIRST_USER_ID].map((v) => v.toString())
    const filtered = filter.map((v) => v.filter((x) => targetColumnNames.includes(x.column_name))).flat()
    const user_ids = Array.from(new Set(filtered.map((v) => v.value_safe).flat())) as string[]
    const allUsers = allVisibleUsers?.every((v) => user_ids.includes(v.user_id))
    if (user_ids.length === 0) { return [] }
    if (allUsers) {
      if (user?.team_id) return [ { user_group_id: null, user_id: null, team_id: user?.team_id } ]
    }
    // check which user groups may be selected (in which case don't select those reps individually)
    const user_groups = sortedUserGroupInfo.filter((v) => {
      const visible_users = v.allUserIds.filter((x) => allVisibleUserIds.includes(x))
      if (!visible_users.length) return false
      return visible_users.every((x) => user_ids.includes(x))
    })
    // only select user_groups that have no parent selected
    const user_groups_to_select = user_groups.filter((v) => {
      const all_user_group_ids = user_groups.map((x) => x.group.user_group_id)
      const parent_idx = v.parentIdxs.map((y) => sortedUserGroupInfo[y]).find((v) => v && all_user_group_ids.includes(v.group.user_group_id))
      return !parent_idx
    })
    const user_group_user_ids = user_groups_to_select.map((v) => v.allUserIds).flat()
    const remaining_individuals = user_ids.filter((v) => !user_group_user_ids.includes(v))
    return [
      ...user_groups_to_select.map((v) => ({ user_group_id: v.group.user_group_id, user_id: null, team_id: null })),
      ...remaining_individuals.map((v) => ({ user_group_id: null, user_id: v, team_id: null }))
    ]
  }, [filter, allVisibleUsers, allVisibleUserIds, sortedUserGroupInfo, user])
}